import QualifiPage from "@/pages/QualifiPage";
import { QUALIFI_EDUCATION } from "@/lib/qualifi";

export default function QualifiEducation() {
  return (
    <QualifiPage
      overline="Teaching & Assessment"
      titleLines={[
        <span key="1" className="text-white">Qualifi</span>,
        <span key="2" className="text-gold">Education.</span>,
      ]}
      intro="Ofqual-regulated teaching, assessment and internal quality assurance qualifications for practitioners and professionals moving into education. Combining engaging theory with practical teaching and assessment experience, our programmes are delivered in small groups with personalised tutor support."
      qualifications={QUALIFI_EDUCATION}
    />
  );
}
